import { useTranslation } from "react-i18next";
import i18n, { HELP_LANG_KEY, LANGS } from "@/i18n";

const NAMES = { it: "Italiano", en: "English", es: "Español" };

// Help language is applied once, BEFORE the first help render (module load): no request ever starts in the wrong language.
export function initHelpLang() {
  const saved = localStorage.getItem(HELP_LANG_KEY);
  const lng = LANGS.includes(saved) ? saved : "it";  // U1: the help centre starts in Italian like the client area; the IT/EN/ES choice is remembered
  if (i18n.language !== lng) i18n.changeLanguage(lng);
}
initHelpLang();

// Same i18next instance as the public site; the choice is remembered on this device. Changing it never remounts forms.
export function useHelpLang() {
  const { t, i18n: inst } = useTranslation("help");
  const l = inst.resolvedLanguage || inst.language;
  return { t, lang: LANGS.includes(l) ? l : "it" };
}

export function HelpLang({ lang }) {
  const { t } = useTranslation("help");
  const pick = (l) => { localStorage.setItem(HELP_LANG_KEY, l); i18n.changeLanguage(l); };
  return (
    <div role="group" aria-label={t("lang_label")} className="inline-flex rounded-full border border-slate-200 bg-white p-0.5" data-testid="help-lang">
      {["it", "en", "es"].map((l) => (
        <button key={l} type="button" lang={l} onClick={() => pick(l)} aria-pressed={lang === l} title={NAMES[l]}
          className={`min-h-[36px] min-w-[44px] rounded-full px-3 text-xs font-semibold uppercase transition-colors ${lang === l ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}
          data-testid={`help-lang-${l}`}>{l}</button>))}
    </div>);
}
